import SearchSection from "@/components/SearchSection.vue";
import AppointmentSelect from "@/components/AppointmentSelect.vue";
import Confirmation from "@/components/Confirmantion.vue";
import FamilyMemberList from "@/components/FamilyMemberList.vue";
import AddFamilyMembers from "@/components/AddFamilyMembers.vue";
import EditFamilyMember from "@/components/EditFamilyMember.vue";
import Personal from "@/components/Personal.vue";
import History from "@/components/History.vue";
import Introduction from "@/components/Introduction.vue";
import Payment from '@/components/Payment.vue';
import {RouteConfig} from "vue-router";
import store from '@/store';

export default [
    {
        path: '/search',
        name: 'search-section',
        component: SearchSection,
        meta: {
            auth: false,
            transitionName: 'slide',
        }
    },
    {
        path: '/appointment',
        name: 'appointment-select',
        component: AppointmentSelect,
        meta: {
            auth: false,
            transitionName: 'slide',
        },
        props: true,
        beforeEnter(to, from, next){
            if(to.query.doctor !== undefined || to.query.service !== undefined) {
                next();
            } else {
                next('/search');
            }
        }
    },
    {
        path: '/confirmation',
        name: 'confirmation',
        component: Confirmation,
        meta: {
            auth: false,
            transitionName: 'slide',
        },
        // beforeEnter(to, from, next) {
        //     if (store.getters['root/getAppointmentList'].length > 0) {
        //         next();
        //     }
        // }
    },
    {
        path: '/payment',
        name: 'payment',
        component: Payment,
        meta: {
            auth: false,
            transitionName: 'slide',
        },
        // beforeEnter(to, from, next) {
        //     if (store.getters['root/getAppointmentList'].length === 0) {
        //         next();
        //     }
        // }
    },
    {
        path: '/family',
        name: 'family',
        component: FamilyMemberList,
        meta: {
            auth: true,
            transitionName: 'slide',
        }
    },
    {
        path: '/members',
        name: 'members',
        component: AddFamilyMembers,
        meta: {
            auth: true,
            transitionName: 'slide',
        }
    },
    {
        path: '/member/edit/:user',
        name: 'member-edit',
        component: EditFamilyMember,
        meta: {
            auth: true,
            transitionName: 'slide',
        },
        props: true
    },
    {
        path: '/personal',
        name: 'personal',
        component: Personal,
        meta: {
            auth: true,
            transitionName: 'slide',
        }
    },
    {
        path: '/history',
        name: 'history',
        component: History,
        meta: {
            auth: true,
            transitionName: 'slide',
        }
    },
    {
        path: '/',
        name: 'introduction',
        component: Introduction,
        meta: {
            auth: false,
            transitionName: 'slide',
        }
    }
] as Array<RouteConfig>;